import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosPriorityChangeRequest } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class ChangeMainEntegrePosApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/changeMainEntegrePos',
      requesterInfo,
    })
  }

  public async changeMainEntegrePos(request: IPosPriorityChangeRequest): Promise<any> {
    return await this.postAsync<IPosPriorityChangeRequest>(request)
  }
}